import {useEffect} from 'react';

const useEventListener = (type: string, listener: EventListenerOrEventListenerObject) => {
    useEffect(() => {
        document.addEventListener(type, listener);

        return () => document.removeEventListener(type, listener);
    }, []);
};

export default useEventListener;
